


export function Testimonials() {
    return (
        <div className="Testimonials-parent-div">
            <h1 className="pill">Testimonials</h1>
            <div className="philosophy-pillars">

                <div className="pillar">
                    <div className="pillar-icon"><b>🧑🏻‍🦱</b></div>
                    <h3 className="pillar-title">⭐⭐⭐⭐⭐</h3>
                    <p className="pillar-description">
                        “A beautiful place for real art lovers”
                        I found unique, high-quality paintings that I couldn’t find anywhere else. The artists are genuine, the artwork feels authentic, and the buying process is smooth and secure. This platform truly supports creativity.<br />
                        <span className="name">— Ahsan R., Art Collector</span>
                    </p>
                </div>

                <div className="pillar">
                    <div className="pillar-icon"><b>👨🏻‍🦱</b></div>
                    <h3 className="pillar-title">⭐⭐⭐⭐⭐</h3>
                    <p className="pillar-description">

                        “Finally, a marketplace that values artists”
                        As a painter, this website gave me the perfect space to showcase and sell my work. The presentation of paintings is elegant, and buyers actually appreciate original art. I’ve gained both income and confidence here. <br />
                        <span className="name">— Hassan K., Visual Artist</span>
                    </p>
                </div>

                <div className="pillar">
                    <div className="pillar-icon"><b>👩🏻‍🦱</b></div>
                    <h3 className="pillar-title">⭐⭐⭐⭐⭐</h3>
                    <p className="pillar-description">
                        “Simple, elegant, and trustworthy”
                        Browsing paintings feels like walking through an online gallery. The filters, categories, and artwork previews make it easy to find exactly what matches your taste. A wonderful experience for both buyers and sellers. <br />
                        <span className="name">— Sarah M., Art Enthusiast</span>
                    </p>
                </div>
            </div>
        </div>
    );
}
